let data: any;
export const loadConfig = (configuration: any) => {
  data = configuration;
};

export const getConfig = (key: string): string | undefined => {
  if (data) {
    return data[key];
  } else {
    return process.env[key];
  }
};

export const getApiEndpoint = () => {
  return getConfig('REACT_APP_AGREMENT_API_ENDPOINT') || '';
};

export const getKeycloakUrl = () => {
  return getConfig('REACT_APP_AGREMENT_KEYCLOAK_URL') || '';
};

export const getSentryUrl = () => {
  return getConfig('REACT_APP_AGREMENT_SENTRY_URL') || '';
};

export const getSentryEnvironment = () => {
  return getConfig('REACT_APP_AGREMENT_SENTRY_ENVIRONMENT') || '';
};

export const getNetheosEndpoint = () => {
  return getConfig('REACT_APP_AGREMENT_NETHEOS_URL') || '';
};
export const getKeycloakRealm = () => {
  return getConfig('REACT_APP_AGREMENT_KEYCLOAK_REALM') || '';
};

export const getKeycloakClientId = () => {
  return getConfig('REACT_APP_AGREMENT_KEYCLOAK_CLIENT_ID') || '';
};

export const getInfoMaintenance = () => {
  return getConfig('REACT_APP_AGREMENT_INFOMAINTENANCE') || '';
};

export const getMessageMaintenance = () => {
  return getConfig('REACT_APP_AGREMENT_MSGINFOMAINTENANCE') || '';
};

export const getMatomoAnalyticsManager = () => {
  return getConfig('REACT_APP_AGREMENT_MATOMO') || '';
};

export const getAxeptioCookieManager = () => {
  return getConfig('REACT_APP_AGREMENT_AXEPTIO') || '';
};
